import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDSIC_HLP_USU;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
